import type { CASLRule } from "@iotos/ims-auth-sdk/permissions";
import { mapStringPermissions } from "@iotos/ims-auth-sdk/permissions";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { RootState } from "../../store-types";
import { IAuthState } from "../shared/interfaces/auth-state";

import { AUTH_MODULE_NAME } from "./constants";

export const getAuthState = (rootState: RootState): IAuthState =>
  rootState[AUTH_MODULE_NAME];

export const getUser = createDraftSafeSelector(
  getAuthState,
  (state: IAuthState) => state.user
);

export const getUserId = createDraftSafeSelector(getUser, (user) => user?.userId ?? null);

export const getIsAuthenticated = createDraftSafeSelector(
  getAuthState,
  (state: IAuthState) => state.isAuthenticated
);

export const getLoadingUserDto = createDraftSafeSelector(
  getAuthState,
  (state: IAuthState) => state.isLoadingUserDto
);

export const getError = createDraftSafeSelector(
  getAuthState,
  (state: IAuthState) => state.error
);

export const getSessionCheckFailure = createDraftSafeSelector(
  getAuthState,
  (state: IAuthState) => state.sessionCheckFailure
);

const featureFlagToAction = (flag: string): string =>
  flag.startsWith("allow") ? flag.charAt(5).toLowerCase() + flag.slice(6) : flag;

export const mapFeatureRules = (
  features?: Record<string, Record<string, boolean>>
): CASLRule[] =>
  Object.entries(features ?? {}).flatMap(([subject, flags]) =>
    Object.entries(flags ?? {})
      .filter(([, isAllowed]) => isAllowed)
      .map(([flag]) => ({ action: featureFlagToAction(flag), subject }))
  );

export const getPermissionRules = createDraftSafeSelector(getUser, (user) => [
  ...mapStringPermissions(user?.permissions ?? []),
  ...mapFeatureRules(user?.features),
]);
